import { Ref, ref } from '@vue/composition-api';
import { VueConstructor } from 'vue';

export interface UseAsyncModal {
	isModalVisible: Ref<boolean>;
	modalView: Ref<null | VueConstructor>;
	loadModalView(): Promise<void>;
	showModal(returnTo?: FocusableElement): void;
	closeModal(): void;
}

export interface FocusableElement extends HTMLElement {
	focus(): void;
}

export const isFocusableElement = <T>(item: FocusableElement | T): item is FocusableElement => item && typeof (item as FocusableElement).focus === 'function';

export const useAsyncModal = (
	buttonId: string,
	fetchModalView: () => Promise<VueConstructor>,
): UseAsyncModal => {
	let returnTo: null | FocusableElement = null;
	const isModalVisible = ref(false);
	const modalView = ref(null as null | VueConstructor);
	const loadModalView = () => fetchModalView()
		.then((theView) => {
			modalView.value = theView;
		});
	const showModal = async (newReturnTo?: FocusableElement) => {
		returnTo = newReturnTo || null;
		await loadModalView();
		isModalVisible.value = true;
	};
	const closeModal = () => {
		isModalVisible.value = false;
		const opener = document.getElementById(buttonId) as HTMLButtonElement | null;
		if (opener) {
			opener.focus();
		} else if (returnTo) {
			returnTo.focus();
		}
	};
	setTimeout(loadModalView, 4000);

	return {
		isModalVisible,
		modalView,
		loadModalView,
		showModal,
		closeModal,
	};
};
